module.exports = __webpack_public_path__ + "img/15_33.8bf348f0.png";